<template>
  <div v-loading="wornLoadShow">
    <el-card class="box-card">
      <el-form ref="formData" label-width="120px" class="demo-ruleForm">
        <el-row :gutter="24">
          <el-col :span="24" v-if='formStatusData.apply_return == 1'>
            <span style="color:blue">用户申请：</span>
          </el-col>
          <div v-if='formStatusData.apply_return == 1' v-for="appu in formStatusData.apply_content">
            <el-col :span="24">
              <div style="color:red">{{ appu.cate_name }}</div>
            </el-col>
            <div v-for="appsku in appu.sku_list">
              <el-col :span="12">
                <el-form-item label="申请sku：">
                  <span>{{ appsku.sku }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="申请数量：">
                  <span>{{ appsku.num }}</span>
                </el-form-item>
              </el-col>
            </div>
          </div>
          <el-col :span="24">
            <span style="color:blue">选择退回的sku列表：</span>
          </el-col>
          <div v-for="exprei in formStatusData.express_list">
            <el-col :span="12">
              <el-form-item label="物流单号：">
                <span>{{ exprei.express_num }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="物流公司：">
                <span>{{ exprei.express_company }}</span>
              </el-form-item>
            </el-col>
            <div v-for="itemp in exprei.product_list">
              <el-col :span="24">
                <div style="color:red">{{ itemp.cate_name }}</div>
              </el-col>
              <div v-for="(ito,indexito) in itemp.sku_list" style="padding-bottom: 20px;border-bottom: 2px solid #f4f4f4;display: inline-block">
                <el-col :span="10">
                  <el-form-item label="sku：">
                    <span>{{ ito.sku }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item label="数量：">
                    <el-input v-model="ito.warehous_count" type="number" v-if = 'ito.warehous_count > 0 && ito.sku_product_return == 0'/>
                    <span v-if = 'ito.warehous_count <= 0 || ito.sku_product_return > 0'>{{ito.num}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="6" v-if = 'ito.warehous_count > 0'>
                  <el-form-item label="">
                    <el-checkbox v-model="ito.worn_check" :true-label="1" :false-label="0"/>
                  </el-form-item>
                </el-col>
                <el-col :span="6" v-if = 'ito.warehous_count <=0'>
                  <span v-if = 'ito.sku_product_return > 0'>已申请退回</span>
                  <span v-if = 'ito.sku_product_return == 0'>已全部出库</span>
                </el-col>
                <el-col :span="24" v-if="ito.is_worn == 0">
                  <el-form-item label="是否异常：">
                    {{ ito.is_worn ? '异常' : '否' }}
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="ito.is_worn">
                  <el-form-item label="是否异常：">
                    {{ ito.is_worn ? '异常' : '否' }}
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="ito.is_worn">
                  <el-form-item label="异常数量：">
                    {{ ito.worn_num }}
                  </el-form-item>
                </el-col>
                <el-col :span="24" v-if="ito.is_worn">
                  <el-form-item label="异常备注：">
                    {{ ito.remark }}
                  </el-form-item>
                </el-col>
                <el-col :span="24" v-if="ito.is_worn">
                  <el-form-item label="异常图片：">
                    <div v-for="itoi in ito.image"
                         style="display: inline-block;">
                      <el-image
                        style="width: 80px; height: 80px"
                        :src="itoi || ''"
                        :preview-src-list="[itoi?itoi:'']"
                      />
                    </div>
                  </el-form-item>
                </el-col>

              </div>
            </div>
          </div>
          <div class="has-bot">
            <el-col :span="24">
              <el-form-item label="备注：">
                <el-input v-model="formStatusData.worn_handle_remark" type="text"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="取件地址：">
                <el-input v-model="formStatusData.platform_address" type="text"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="取件联系人：">
                <el-input v-model="formStatusData.platform_name" type="text"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="取件联系电话：">
                <el-input v-model="formStatusData.platform_phone" type="text"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item v-if="formStatusData.worn_apply_address" label="回寄地址：">
                <el-input v-model="formStatusData.worn_apply_address" type="text"/>
              </el-form-item>
              <el-form-item v-else label="回寄地址：">
                <el-input v-model="formStatusData.user_address" type="text"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="回寄联系人：">
                <el-input v-model="formStatusData.worn_apply_name?formStatusData.worn_apply_name:formStatusData.user_name" type="text"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="回寄联系电话：">
                <el-input v-model="formStatusData.worn_apply_mobile?formStatusData.worn_apply_mobile:formStatusData.user_phone" type="text"/>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="" style="display: block;">
                <el-radio v-model="formStatusData.express_type" :label="1">自行寄件</el-radio>
                <el-radio v-model="formStatusData.express_type" :label="2">预约取件</el-radio>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="选择物流：" style="display: block;">
                <el-select
                  v-model="formStatusData.wore_handle_express_number"
                  clearable
                  filterable
                  placeholder="请选择"
                  class="selWidth"
                >
                  <el-option
                    v-for="item in formStatusData.company_list"
                    :key="item.express_number"
                    :label="item.express_name"
                    :value="item.express_number"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="formStatusData.express_type == 1">
              <el-form-item label="物流单号：" style="display: block;">
                <el-input v-model="formStatusData.express_num" placeholder="请输入物流单号" style="width: 300px"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24" v-if="formStatusData.express_type == 2">
              <el-form-item label="预约取件时间：" style="display: block;">
                <el-select
                  v-model="formStatusData.express_day_type"
                  clearable
                  filterable
                  placeholder="请选择"
                  class="selWidth"
                  @change="change"
                >
                  <el-option
                    v-for="item in expressDayTypeList"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="formStatusData.express_type == 2">
              <el-form-item label="预约取件时间范围：" style="display: block;">
                <el-time-select
                  placeholder="起始时间"
                  v-model="express_pickup_time.express_pickup_start "
                  :picker-options="{
                  start: '06:00',
                  step: '01:00',
                  end: '22:00',
                  minTime:minTime,
                  maxTime:'22:00'
                }"
                >
                </el-time-select>
                -
                {{timeEndFn}}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button type="primary" @click="onSubmit">提交</el-button>
              </el-form-item>
            </el-col>
          </div>
        </el-row>
      </el-form>
    </el-card>

  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import {userOrderApi, userDetailApi, userCouponApi, userBillApi, modifyUserRefLog} from '@/api/user'
import {
  recoveryOrderDetailApi,
  recoveryOrderListApi,
  recoveryOrderUpdateSublimitApi,
  recoveryOrderWoreHandleSublimitApi
} from "@/api/recovery";

export default {
  name: 'OrderWornHandle',
  props: {
    recovery_order_id: {
      type: Number,
      default: null
    },
  },
  data() {
    return {
      radio:1,
      minTime:'',
      moren: require("@/assets/images/f.png"),
      loading: false,
      columns: [],
      wornLoadShow:false,
      Visible: false,
      formStatusData: {
        express_day_type: '',
        express_type:1,
        express_num:''
      },

      express_pickup_time: {
        express_pickup_start:'',
        express_pickup_end:''
      },
      expressDayTypeList: [
        '今天', '明天', '后天'
      ],
      psInfo: null,
      type: '0'
    }
  },
  computed:{
    timeEndFn(){
      if(this.express_pickup_time.express_pickup_start){
        let t=parseInt(this.express_pickup_time.express_pickup_start.split(':')[0])
        if(t<9){
          this.express_pickup_time.express_pickup_end='0'+(t+1)+':00'
          return '0'+(t+1)+':00'
        }else{
          this.express_pickup_time.express_pickup_end=(t+1)+':00'
          return (t+1)+':00'
        }
      }else{
        return '结束时间为开始时间1小时之后'
      }

    }
  },
  mounted() {
    if (this.recovery_order_id) {
      this.getInfo('0')
    }
  },
  methods: {
    change(e){
      this.express_pickup_time.express_pickup_start=''
      if(e=='今天'){
        this.minTime=new Date().getHours()+':00'
      }else{
        this.minTime=''
      }
    },
    getInfo() {
      this.wornLoadShow = true
      this.loading = true
      recoveryOrderDetailApi(this.recovery_order_id).then((res) => {
        this.formStatusData = {...res.data,...this.formStatusData}
        this.loading = false
        this.wornLoadShow = false
      }).catch(() => {
        this.loading = false
        this.wornLoadShow = false
      })
    },
    onSubmit() {
      if(this.formStatusData.express_type == 2){
        this.formStatusData.express_num = ''
      }
      if(!this.formStatusData.worn_apply_address){
        this.formStatusData.worn_apply_address = this.formStatusData.user_address
        this.formStatusData.worn_apply_mobile = this.formStatusData.user_phone
        this.formStatusData.worn_apply_name = this.formStatusData.user_name
      }
      this.formStatusData.status = this.status;
      this.formStatusData={...this.formStatusData,...this.express_pickup_time}
      this.wornLoadShow = true
      recoveryOrderWoreHandleSublimitApi(this.formStatusData.recovery_order_id, this.formStatusData).then(res => {
        this.$message.success(res.message)
        this.dialogVisibleStatus = false
        this.$emit("sendSuccess");
        this.minTime=''
        this.express_pickup_time= {
          express_pickup_start:'',
            express_pickup_end:''
        }
        this.wornLoadShow =  false
      }).catch(res => {
        this.wornLoadShow = false
        this.$message.error(res.message)
      })
    },
  }
}
</script>

<style scoped lang="scss">
.box-card .el-form-item {
  margin-bottom: 0;
}

.has-bot .el-form-item {
  margin-bottom: 20px;
}

.avatar {
  width: 60px;
  height: 60px;
  margin-left: 18px;

  img {
    width: 100%;
    height: 100%;
  }
}

.dashboard-workplace {
  &-header {
    &-avatar {
      /*width: 64px;*/
      /*height: 64px;*/
      /*border-radius: 50%;*/
      margin-right: 16px;
      font-weight: 600;
    }

    &-tip {
      width: 82%;
      display: inline-block;
      vertical-align: middle;
      margin-top: -12px;

      &-title {
        font-size: 13px;
        color: #000000;
        margin-bottom: 12px;
      }

      &-desc {
        &-sp {
          width: 32%;
          color: #17233D;
          font-size: 13px;
          display: inline-block;
        }
      }
    }

    &-extra {
      .ivu-col {
        p {
          text-align: right;
        }

        p:first-child {
          span:first-child {
            margin-right: 4px;
          }

          span:last-child {
            color: #808695;
          }
        }

        p:last-child {
          font-size: 22px;
        }
      }
    }
  }
}
</style>
<template>
  <div v-loading="wornLoadShow">
    <el-card class="box-card">
      <el-form ref="formData" label-width="120px" class="demo-ruleForm">
        <el-row :gutter="24">
          <el-col :span="24" v-if='formStatusData.apply_return == 1'>
            <span style="color:blue">用户申请：</span>
          </el-col>
          <div v-if='formStatusData.apply_return == 1' v-for="appu in formStatusData.apply_content">
            <el-col :span="24">
              <div style="color:red">{{ appu.cate_name }}</div>
            </el-col>
            <div v-for="appsku in appu.sku_list">
              <el-col :span="12">
                <el-form-item label="申请sku：">
                  <span>{{ appsku.sku }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="申请数量：">
                  <span>{{ appsku.num }}</span>
                </el-form-item>
              </el-col>
            </div>
          </div>
          <el-col :span="24">
            <span style="color:blue">选择退回的sku列表：</span>
          </el-col>
          <div v-for="exprei in formStatusData.express_list">
            <el-col :span="12">
              <el-form-item label="物流单号：">
                <span>{{ exprei.express_num }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="物流公司：">
                <span>{{ exprei.express_company }}</span>
              </el-form-item>
            </el-col>
            <div v-for="itemp in exprei.product_list">
              <el-col :span="24">
                <div style="color:red">{{ itemp.cate_name }}</div>
              </el-col>
              <div v-for="(ito,indexito) in itemp.sku_list" style="padding-bottom: 20px;border-bottom: 2px solid #f4f4f4;display: inline-block">
                <el-col :span="10">
                  <el-form-item label="sku：">
                    <span>{{ ito.sku }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item label="数量：">
                    <el-input v-model="ito.warehous_count" type="number" v-if = 'ito.warehous_count > 0 && ito.sku_product_return == 0'/>
                    <span v-if = 'ito.warehous_count <= 0 || ito.sku_product_return > 0'>{{ito.num}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="6" v-if = 'ito.warehous_count > 0'>
                  <el-form-item label="">
                    <el-checkbox v-model="ito.worn_check" :true-label="1" :false-label="0"/>
                  </el-form-item>
                </el-col>
                <el-col :span="6" v-if = 'ito.warehous_count <=0'>
                  <span v-if = 'ito.sku_product_return > 0'>已申请退回</span>
                  <span v-if = 'ito.sku_product_return == 0'>已全部出库</span>
                </el-col>
                <el-col :span="24" v-if="ito.is_worn == 0">
                  <el-form-item label="是否异常：">
                    {{ ito.is_worn ? '异常' : '否' }}
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="ito.is_worn">
                  <el-form-item label="是否异常：">
                    {{ ito.is_worn ? '异常' : '否' }}
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="ito.is_worn">
                  <el-form-item label="异常数量：">
                    {{ ito.worn_num }}
                  </el-form-item>
                </el-col>
                <el-col :span="24" v-if="ito.is_worn">
                  <el-form-item label="异常备注：">
                    {{ ito.remark }}
                  </el-form-item>
                </el-col>
                <el-col :span="24" v-if="ito.is_worn">
                  <el-form-item label="异常图片：">
                    <div v-for="itoi in ito.image"
                         style="display: inline-block;">
                      <el-image
                        style="width: 80px; height: 80px"
                        :src="itoi || ''"
                        :preview-src-list="[itoi?itoi:'']"
                      />
                    </div>
                  </el-form-item>
                </el-col>

              </div>
            </div>
          </div>
          <div class="has-bot">
            <el-col :span="24">
              <el-form-item label="备注：">
                <el-input v-model="formStatusData.worn_handle_remark" type="text"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="取件地址：">
                <el-input v-model="formStatusData.platform_address" type="text"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="取件联系人：">
                <el-input v-model="formStatusData.platform_name" type="text"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="取件联系电话：">
                <el-input v-model="formStatusData.platform_phone" type="text"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item v-if="formStatusData.worn_apply_address" label="回寄地址：">
                <el-input v-model="formStatusData.worn_apply_address" type="text"/>
              </el-form-item>
              <el-form-item v-else label="回寄地址：">
                <el-input v-model="formStatusData.user_address" type="text"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="回寄联系人：">
                <el-input v-model="formStatusData.worn_apply_name?formStatusData.worn_apply_name:formStatusData.user_name" type="text"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="回寄联系电话：">
                <el-input v-model="formStatusData.worn_apply_mobile?formStatusData.worn_apply_mobile:formStatusData.user_phone" type="text"/>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="" style="display: block;">
                <el-radio v-model="formStatusData.express_type" :label="1">自行寄件</el-radio>
                <el-radio v-model="formStatusData.express_type" :label="2">预约取件</el-radio>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="选择物流：" style="display: block;">
                <el-select
                  v-model="formStatusData.wore_handle_express_number"
                  clearable
                  filterable
                  placeholder="请选择"
                  class="selWidth"
                >
                  <el-option
                    v-for="item in formStatusData.company_list"
                    :key="item.express_number"
                    :label="item.express_name"
                    :value="item.express_number"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="formStatusData.express_type == 1">
              <el-form-item label="物流单号：" style="display: block;">
                <el-input v-model="formStatusData.express_num" placeholder="请输入物流单号" style="width: 300px"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24" v-if="formStatusData.express_type == 2">
              <el-form-item label="预约取件时间：" style="display: block;">
                <el-select
                  v-model="formStatusData.express_day_type"
                  clearable
                  filterable
                  placeholder="请选择"
                  class="selWidth"
                  @change="change"
                >
                  <el-option
                    v-for="item in expressDayTypeList"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="formStatusData.express_type == 2">
              <el-form-item label="预约取件时间范围：" style="display: block;">
                <el-time-select
                  placeholder="起始时间"
                  v-model="express_pickup_time.express_pickup_start "
                  :picker-options="{
                  start: '06:00',
                  step: '01:00',
                  end: '22:00',
                  minTime:minTime,
                  maxTime:'22:00'
                }"
                >
                </el-time-select>
                -
                {{timeEndFn}}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button type="primary" @click="onSubmit">提交</el-button>
              </el-form-item>
            </el-col>
          </div>
        </el-row>
      </el-form>
    </el-card>

  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import {userOrderApi, userDetailApi, userCouponApi, userBillApi, modifyUserRefLog} from '@/api/user'
import {
  recoveryOrderDetailApi,
  recoveryOrderListApi,
  recoveryOrderUpdateSublimitApi,
  recoveryOrderWoreHandleSublimitApi
} from "@/api/recovery";

export default {
  name: 'OrderWornHandle',
  props: {
    recovery_order_id: {
      type: Number,
      default: null
    },
  },
  data() {
    return {
      radio:1,
      minTime:'',
      moren: require("@/assets/images/f.png"),
      loading: false,
      columns: [],
      wornLoadShow:false,
      Visible: false,
      formStatusData: {
        express_day_type: '',
        express_type:1,
        express_num:''
      },

      express_pickup_time: {
        express_pickup_start:'',
        express_pickup_end:''
      },
      expressDayTypeList: [
        '今天', '明天', '后天'
      ],
      psInfo: null,
      type: '0'
    }
  },
  computed:{
    timeEndFn(){
      if(this.express_pickup_time.express_pickup_start){
        let t=parseInt(this.express_pickup_time.express_pickup_start.split(':')[0])
        if(t<9){
          this.express_pickup_time.express_pickup_end='0'+(t+1)+':00'
          return '0'+(t+1)+':00'
        }else{
          this.express_pickup_time.express_pickup_end=(t+1)+':00'
          return (t+1)+':00'
        }
      }else{
        return '结束时间为开始时间1小时之后'
      }

    }
  },
  mounted() {
    if (this.recovery_order_id) {
      this.getInfo('0')
    }
  },
  methods: {
    change(e){
      this.express_pickup_time.express_pickup_start=''
      if(e=='今天'){
        this.minTime=new Date().getHours()+':00'
      }else{
        this.minTime=''
      }
    },
    getInfo() {
      this.wornLoadShow = true
      this.loading = true
      recoveryOrderDetailApi(this.recovery_order_id).then((res) => {
        this.formStatusData = {...res.data,...this.formStatusData}
        this.loading = false
        this.wornLoadShow = false
      }).catch(() => {
        this.loading = false
        this.wornLoadShow = false
      })
    },
    onSubmit() {
      if(this.formStatusData.express_type == 2){
        this.formStatusData.express_num = ''
      }
      if(!this.formStatusData.worn_apply_address){
        this.formStatusData.worn_apply_address = this.formStatusData.user_address
        this.formStatusData.worn_apply_mobile = this.formStatusData.user_phone
        this.formStatusData.worn_apply_name = this.formStatusData.user_name
      }
      this.formStatusData.status = this.status;
      this.formStatusData={...this.formStatusData,...this.express_pickup_time}
      this.wornLoadShow = true
      recoveryOrderWoreHandleSublimitApi(this.formStatusData.recovery_order_id, this.formStatusData).then(res => {
        this.$message.success(res.message)
        this.dialogVisibleStatus = false
        this.$emit("sendSuccess");
        this.minTime=''
        this.express_pickup_time= {
          express_pickup_start:'',
            express_pickup_end:''
        }
        this.wornLoadShow =  false
      }).catch(res => {
        this.wornLoadShow = false
        this.$message.error(res.message)
      })
    },
  }
}
</script>

<style scoped lang="scss">
.box-card .el-form-item {
  margin-bottom: 0;
}

.has-bot .el-form-item {
  margin-bottom: 20px;
}

.avatar {
  width: 60px;
  height: 60px;
  margin-left: 18px;

  img {
    width: 100%;
    height: 100%;
  }
}

.dashboard-workplace {
  &-header {
    &-avatar {
      /*width: 64px;*/
      /*height: 64px;*/
      /*border-radius: 50%;*/
      margin-right: 16px;
      font-weight: 600;
    }

    &-tip {
      width: 82%;
      display: inline-block;
      vertical-align: middle;
      margin-top: -12px;

      &-title {
        font-size: 13px;
        color: #000000;
        margin-bottom: 12px;
      }

      &-desc {
        &-sp {
          width: 32%;
          color: #17233D;
          font-size: 13px;
          display: inline-block;
        }
      }
    }

    &-extra {
      .ivu-col {
        p {
          text-align: right;
        }

        p:first-child {
          span:first-child {
            margin-right: 4px;
          }

          span:last-child {
            color: #808695;
          }
        }

        p:last-child {
          font-size: 22px;
        }
      }
    }
  }
}
</style>
